import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import b from "./util/net.js";
import ue from "./models/braze-event.js";
import s from "./common/event-logger.js";
import { randomInclusive as lt } from "./util/math.js";
import t from "./models/request-result.js";
import r from "../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "./managers/storage-manager.js";
import u from "./managers/subscription-manager.js";
import ht from "./Push/utils/push-utils.js";

var Ot = /*#__PURE__*/function () {
  function Ot(t, s, i, e, n, l, h, o, r, a) {
    _classCallCheck(this, Ot);

    this.Ji = t, this.yo = s, this.kl = 0, this.yl = h.Ba(), this.Sl = null, this.j = i, this.Qi = e, this.v = n, this.gt = l, this.h = h, this.Bo = r, this.vt = a, this.$l = o, this.Al = new u(), this._l = 50;
  }

  _createClass(Ot, [{
    key: "ql",
    value: function ql(t, s) {
      return !t && !s && this.Bo.Qn() >= this._l;
    }
  }, {
    key: "Dl",
    value: function Dl(t) {
      var s = this.j.hh();

      if (t.length > 0) {
        var i = this.v.getUserId();

        var _iterator = _createForOfIteratorHelper(t),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;

            var _t = !e.userId && !i || e.userId === i;

            e.type === r.A.ph && _t && (s = !0);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return s;
    }
  }, {
    key: "Ll",
    value: function Ll(t, s, i, e, n, l, h) {
      var _this = this;

      null == i && (i = !0), i && this.Pl();
      var u = this.h.Ca(),
          a = this.h.Ua();
      var c = !1;

      var m = function m(t, s) {
        var h = !1;
        b.Hs({
          url: _this.yo + "/data/",
          data: t,
          headers: s,
          S: function S(i) {
            null != t.respond_with && t.respond_with.triggers && (_this.kl = Math.max(_this.kl - 1, 0)), _this.vt.Os(t, i, s) ? (_this.Bo.Qs(), _this.gt.al(i), null != t.respond_with && t.respond_with.user_id != _this.v.getUserId() || (null != t.device && _this.h.B(o.q.Ho, t.device), null != t.sdk_metadata && (_this.h.B(o.q.Yo, t.sdk_metadata), _this.h.B(o.q.Zo, _this.j.Vo())), _this.$l(i), "function" == typeof e && e())) : i.auth_error && (h = !0);
          },
          error: function error() {
            null != t.respond_with && t.respond_with.triggers && (_this.kl = Math.max(_this.kl - 1, 0)), _this.vt.sa(t.events, t.attributes), "function" == typeof n && n();
          },
          Rl: function Rl(t) {
            if ("function" == typeof l && l(t), i && !c) {
              if (t && !h) _this.Ml();else {
                var _t2 = _this.Sl;
                (null == _t2 || _t2 < 1e3 * _this.yl) && (_t2 = 1e3 * _this.yl), _this.Ml(Math.min(3e5, lt(1e3 * _this.yl, 3 * _t2)));
              }
              c = !0;
            }
          }
        });
      },
          d = this.Dl(u),
          f = s || d;

      if (this.ql(h, d)) return void r.D.info("Declining to flush data due to 50 consecutive authentication failures");
      if (i && !this.vt.fa(u, a, t, f)) return this.Ml(), void ("function" == typeof l && l(!0));
      var g = this.vt.ma(t, f, u, a);
      f && this.kl++;
      var p = !1;

      if (g) {
        var _iterator2 = _createForOfIteratorHelper(g),
            _step2;

        try {
          var _loop = function _loop() {
            var t = _step2.value;
            _this.vt.Gs(t.requestData, function () {
              return m(t.requestData, t.headers);
            }), p = !0;
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.Bo.Gn() && i && !p ? this.Ml() : d && (r.D.info("Invoking new session subscriptions"), this.Al.St());
    }
  }, {
    key: "Il",
    value: function Il() {
      return this.kl > 0;
    }
  }, {
    key: "Ml",
    value: function Ml(t) {
      var _this2 = this;

      this.Nl || (null == t && (t = 1e3 * this.yl), this.Pl(), this.Ol = setTimeout(function () {
        if (document.hidden) {
          var _t3 = "visibilitychange",
              _s = function _s() {
            document.hidden || (document.removeEventListener(_t3, _s, !1), _this2.Ll());
          };

          document.addEventListener(_t3, _s, !1);
        } else _this2.Ll();
      }, t), this.Sl = t);
    }
  }, {
    key: "Pl",
    value: function Pl() {
      null != this.Ol && (clearTimeout(this.Ol), this.Ol = null);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.Nl = !1, this.Ml();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.Al.removeAllSubscriptions(), this.Bo.On(), this.Pl(), this.Nl = !0, this.Ll(null, null, !1), this.Ol = null;
    }
  }, {
    key: "cr",
    value: function cr(t) {
      return this.Al.ut(t);
    }
  }, {
    key: "openSession",
    value: function openSession() {
      var _this3 = this;

      var t = this.j.Vo() !== this.j.mo();
      t && (this.h.va(o.iu.Go), this.h.va(o.iu.su)), this.Ll(null, !1, null, null, null), this.$n(), t && import("./Push/push-manager-factory.js").then(function (t) {
        if (_this3.Nl) return;
        var s = t.default.aa();

        if (null != s && (ht.isPushPermissionGranted() || ht.isPushBlocked())) {
          var _t4 = function _t4() {
            s.Er() ? r.D.info("Push token maintenance is disabled, not refreshing token for backend.") : s.subscribe();
          },
              i = function i(s, _i) {
            _i && _t4();
          },
              e = function e() {
            var s = _this3.h.I(o.q.gn);

            (null == s || s) && _t4();
          },
              n = r.xt.Ft;

          new r.qt(n, r.D).hr(n.$t.pu, i, e);
        }
      });
    }
  }, {
    key: "changeUser",
    value: function changeUser(t, s, i) {
      var e = this.v.getUserId();

      if (e !== t) {
        this.j.gh(), null != e && this.Ll(null, !1, null, null, null), this.v.uu(t), i ? this.Bo.setSdkAuthenticationSignature(i) : this.Bo.Ln();

        for (var _t5 = 0; _t5 < s.length; _t5++) {
          s[_t5].changeUser(null == e);
        }

        null != e && this.h.Xs(o.q.P), this.h.Xs(o.q.Ho), this.openSession(), r.D.info('Changed user to "' + t + '".');
      } else {
        var _s2 = "Doing nothing.";
        i && this.Bo.Hn() !== i && (this.Bo.setSdkAuthenticationSignature(i), _s2 = "Updated SDK authentication signature"), r.D.info("Current user is already ".concat(t, ". ").concat(_s2));
      }
    }
  }, {
    key: "requestImmediateDataFlush",
    value: function requestImmediateDataFlush(t) {
      this.Pl(), this.j.mo(), this.Ll(null, null, null, null, null, t, !0);
    }
  }, {
    key: "requestFeedRefresh",
    value: function requestFeedRefresh() {
      this.j.mo(), this.Ll(!0);
    }
  }, {
    key: "zr",
    value: function zr(t, s) {
      this.j.mo(), r.D.info("Requesting explicit trigger refresh."), this.Ll(null, !0, null, t, s);
    }
  }, {
    key: "Nn",
    value: function Nn(t, i) {
      var e = r.A.Ul,
          n = {
        a: t,
        l: i
      },
          l = s.G(e, n);
      return l && r.D.info("Logged alias ".concat(t, " with label ").concat(i)), l;
    }
  }, {
    key: "In",
    value: function In(i, e, n) {
      if (this.gt.hu(e)) return r.D.info("Custom Attribute \"".concat(e, "\" is blocklisted, ignoring.")), new t();
      var l = {
        key: e,
        value: n
      },
          h = s.G(i, l);
      return h && r.D.info("Logged custom attribute: ".concat(e, " with value: ").concat(n)), h;
    }
  }, {
    key: "setLastKnownLocation",
    value: function setLastKnownLocation(t, i, e, n, l, h) {
      var o = {
        latitude: i,
        longitude: e
      };
      null != n && (o.altitude = n), null != l && (o.ll_accuracy = l), null != h && (o.alt_accuracy = h);
      var u = s.G(r.A.xl, o, t);
      return u && r.D.info("Set user last known location as ".concat(JSON.stringify(o, null, 2))), u;
    }
  }, {
    key: "kr",
    value: function kr(t, s) {
      var i = this.j.mo();
      return new ue(this.v.getUserId(), r.A.Kl, t, i, {
        cid: s
      });
    }
  }, {
    key: "$n",
    value: function $n() {
      var t = r.xt.Ft;
      new r.qt(t, r.D).setItem(t.$t.Wl, 1, {
        baseUrl: this.yo,
        data: {
          api_key: this.Ji,
          device_id: this.Qi.te().id
        },
        userId: this.v.getUserId(),
        sdkAuthEnabled: this.Bo.Gn()
      });
    }
  }, {
    key: "wr",
    value: function wr(t) {
      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _s3 = _step3.value;
          if (_s3.api_key === this.Ji) this.vt.sa(_s3.events, _s3.attributes);else {
            var _t6 = r.xt.Ft;
            new r.qt(_t6, r.D).setItem(_t6.$t.$r, r.it.nt(), _s3);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "Fn",
    value: function Fn(i, e, n) {
      if (this.gt.hu(i)) return r.D.info("Custom Attribute \"".concat(i, "\" is blocklisted, ignoring.")), new t();
      var l, h;
      return null === e && null === n ? (l = r.A.Bl, h = {
        key: i
      }) : (l = r.A.Gl, h = {
        key: i,
        latitude: e,
        longitude: n
      }), s.G(l, h);
    }
  }, {
    key: "Tn",
    value: function Tn(t, i) {
      var e = {
        group_id: t,
        status: i
      };
      return s.G(r.A.Jl, e);
    }
  }]);

  return Ot;
}();

export { Ot as default };